module.exports = __webpack_public_path__ + "img/development.05c57ca8.svg";